import { render, staticRenderFns } from "./MathCalendar.vue?vue&type=template&id=45f3ca3f&scoped=true"
import script from "./MathCalendar.vue?vue&type=script&lang=js"
export * from "./MathCalendar.vue?vue&type=script&lang=js"
import style0 from "./MathCalendar.vue?vue&type=style&index=0&id=45f3ca3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f3ca3f",
  null
  
)

export default component.exports